import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  DatePicker,
  Select,
} from "antd";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { create } from "../../../../../controllers/store/actions/universities/create-university-action";
import SelectCities from "../../Elements/Select-Cities";
import { Actor, UniversityRaw } from "../../../..";
import TextArea from "antd/es/input/TextArea";
import SelectRecognition from "../../Elements/Select-Recognize";
import SelectAccredited from "../../Elements/Select-Accredited";
import SelectStates from "../../Elements/Select-States";
import { useState } from "react";
import { MaskedInput } from "antd-mask-input";
import SelectGroup from "../../Elements/Select-Group";
import SelectSearchers from "../../Elements/Select-Searcher";

interface Props {
  loading?: boolean;
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const NewUniversityModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const createdUniversity = useSelector(
    (state: any) => state.createdUniversity
  );
  const actorTypesState = useSelector((state: any) => state.actorTypes);
  const [state, setState] = useState<any>();
  return (
    <Modal
      width={800}
      visible={Props.visible}
      title={"Universidad"}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values) => {
              await dispatch(
                create({
                  contact_name: values.contact_name,
                  contact_email: values.contact_email,
                  institution_name: values.institution_name,
                  institution_code: values.institution_code,
                  universities_entities: [],
                  universities_searchers: [],
                  groups: values?.groups?.map((g: any) => ({
                    groups_id: g.value,
                  })),
                  searchers: values.searchers?.map((g: any) => ({
                    searchers_id: g.value,
                  })),
                  phone: values.phone,
                  is_accredited: values.is_accredited.value,
                  source: values.source,
                  municipality: values.municipality,
                  update_date: new Date(values.update_date).toISOString(),
                  issue_date: new Date(values.issue_date).toISOString(),
                  current_date: new Date(values.current_date).toISOString(),
                  state: values.state.value,
                  description: values.description,
                  actor_type: actorTypesState.list?.find(
                    (c: any) => c.collection_name === Actor.University
                  ).id,
                  recognized_min: values?.recognized_min.value,
                  features: values.features,
                  city: values.city.value,
                  url: values.url,
                })
              );
              form.resetFields();
              Props.onCreated();
            });
          }}
          name="newUniversity"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={18}>
              <Form.Item
                label="Universidad"
                name="institution_name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre de la universidad",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="Código de institución"
                name="institution_code"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el codigo de institución",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Grupos de investigación"
                name="groups"
                rules={[{ type: "array" }]}
              >
                <SelectGroup
                  onClear={() => {}}
                  mode={"multiple"}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("groups", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Investigadores"
                name="searchers"
                rules={[{ type: "array" }]}
              >
                <SelectSearchers
                  onClear={() => {}}
                  mode={"multiple"}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("searchers", selected);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre del contacto",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el email de contacto",
                  },
                  {
                    type: "email",
                    message: "Por favor ingrese un email válido",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Télefono"
                name="phone"
                rules={[{ type: "string", required: true }]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Departamento"
                name="state"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectStates
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("state", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  selectedState={state?.value}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("city", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Descripción"
                name="description"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Acreditada de alta calidad."
                name="is_accredited"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectAccredited
                  onClear={() => {}}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("is_accredited", selected);
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6} lg={8}>
              <Form.Item
                label="Reconocimiento min."
                name="recognized_min"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectRecognition
                  onClear={() => {}}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("recognized_min", selected);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fuente"
                name="source"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Características"
                name="features"
                rules={[{ type: "string" }]}
              >
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fecha de expedición"
                name="issue_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Fecha de expedición"
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Vigencia"
                name="current_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("current_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Vigencia"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Última actualización"
                name="update_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("update_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Última actualización"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item label="URL" name="url" rules={[{ type: "url" }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={createdUniversity?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Agregar Universidad
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default NewUniversityModal;
